import { Editor } from 'slate';
import { noop } from 'lodash';

export const getTableOfContentFromEditor = (editor, onError = noop, headingLevels = ['h2', 'h3', 'h4']) => {
  if (editor) {
    const headingList = [];
    const nodeEntries: any = Editor.nodes(editor, {
      at: [],
    });

    for (const [node] of nodeEntries) {
      if (headingLevels?.includes(node?.type)) {
        headingList.push({
          id: node.id,
          type: node.type,
          children: node.children,
          headingIndex: node.headingIndex,
          orderIndex: node.orderIndex,
          headingLevel: node.headingLevel,
        });
      }
    }

    return headingList;
  }
  return [];
};
